<template>
  <BackgroundWrapper>
    <template #default>
      <FreeSignUp v-if="isAppTenant" />
      <SignUpForm v-else />
    </template>
  </BackgroundWrapper>
</template>

<script>
import BackgroundWrapper from "@/components/_shared/BackgroundWrapper.vue";
import SignUpForm from "@/components/sign-up/SignUpForm.vue";
import { isAppTenant } from "@/utils/utils";
import FreeSignUp from "@/components/sign-up/FreeSignUp.vue";

export default {
  name: "SignUp",
  components: {
    FreeSignUp,
    BackgroundWrapper,
    SignUpForm,
  },
  data() {
    return {
      isAppTenant: isAppTenant(),
    };
  },
};
</script>
